/**
 * Dawn details-disclosure + header-menu, erweitert:
 * 1) focusout: Beim Fokus auf einen anderen Mega-Reiter nicht sofort schließen.
 *    Ebenso: Fokus auf Top-Direktlink (a ohne details) — sonst schließt das Panel vor
 *    dem click und die Navigations-Animation (mm-tab-exiting → Link) sieht man nicht.
 * 2) Reiter-Wechsel: Unterstrich am alten Tab schiebt weg, Panel-Tausch koordiniert.
 *    (Kein Vollflächen-Blocker mehr — der lag mit z-index über dem Panel und hat die
 *    obere Trennlinie / den Schattenbereich kurz „übermalt“.)
 * 3) Mega offen + Klick auf Direktlink: nur Exit-Animation am alten Reiter, dann sofort
 *    Navigation (kein Enter-Balken am Link — sonst bricht die Seite die Animation ab).
 */
function shouldDeferMegaMenuClose(disclosureInstance) {
  var nav = disclosureInstance.closest('.header__inline-menu');
  if (!nav) return false;
  var details = disclosureInstance.mainDetailsToggle;
  if (!details || !details.classList.contains('mega-menu')) return false;
  var active = document.activeElement;
  if (!active || !nav.contains(active)) return false;

  var otherHost = active.closest('header-menu');
  if (otherHost && otherHost !== disclosureInstance) {
    var otherDetails = otherHost.querySelector('details.mega-menu');
    return !!otherDetails;
  }

  if (
    active.matches &&
    active.matches('a.header__menu-item') &&
    !active.closest('details.mega-menu')
  ) {
    return true;
  }

  return false;
}

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(
      function () {
        if (!this.contains(document.activeElement)) {
          if (shouldDeferMegaMenuClose(this)) return;
          this.close();
        }
      }.bind(this)
    );
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(function (animation) {
        animation.play();
      });
    } else {
      this.animations.forEach(function (animation) {
        animation.cancel();
      });
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      String(Math.floor(this.header.getBoundingClientRect().bottom)) + 'px'
    );
  }
}

customElements.define('header-menu', HeaderMenu);

(function () {
  var MQ = typeof window.matchMedia === 'function' ? window.matchMedia('(min-width: 990px)') : null;
  var MQ_REDUCE =
    typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var NAV_SEL = 'nav.header__inline-menu';
  var TAB_LINE_EXIT_MS = 135;
  var TAB_LINE_ENTER_MS = 280;

  function findOpenMega(nav) {
    var list = nav.querySelectorAll('header-menu details.mega-menu');
    for (var i = 0; i < list.length; i++) {
      if (list[i].open) return list[i];
    }
    return null;
  }

  function setAria(details, open) {
    var s = details.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function isPlainPrimaryNavClick(e, anchor) {
    if (e.defaultPrevented) return false;
    if (e.button != null && e.button !== 0) return false;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
    if (anchor.getAttribute('target') === '_blank') return false;
    if (anchor.hasAttribute('download')) return false;
    var href = anchor.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return false;
    return true;
  }

  function megaTabDirClass(openDetails, targetEl) {
    var s = openDetails.querySelector('summary');
    if (!s) return 'mm-tab-dir-forward';
    var ar = s.getBoundingClientRect();
    var br = targetEl.getBoundingClientRect();
    var ax = ar.left + ar.width / 2;
    var bx = br.left + br.width / 2;
    return bx >= ax ? 'mm-tab-dir-forward' : 'mm-tab-dir-back';
  }

  document.addEventListener(
    'toggle',
    function (ev) {
      var t = ev.target;
      if (!t.matches || !t.matches('details.mega-menu')) return;
      if (t.open) return;
      var c = t.querySelector('.mega-menu__content');
      if (c) c.classList.remove('mm-reiter-stable');
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!MQ || !MQ.matches) return;
      var summary = e.target.closest && e.target.closest('summary.header__menu-item');
      if (!summary) return;
      var nav = summary.closest(NAV_SEL);
      if (!nav) return;
      var targetDetails = summary.closest('details');
      if (!targetDetails || !targetDetails.classList.contains('mega-menu')) return;

      var openDetails = findOpenMega(nav);
      if (!openDetails || openDetails === targetDetails) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var reduce = MQ_REDUCE && MQ_REDUCE.matches;
      var oldContent = openDetails.querySelector('.mega-menu__content');
      var newContent = targetDetails.querySelector('.mega-menu__content');
      var oldHm = openDetails.closest('header-menu');
      var newHm = targetDetails.closest('header-menu');

      if (!oldContent || !newContent || !oldHm || !newHm) {
        targetDetails.open = true;
        setAria(targetDetails, true);
        openDetails.open = false;
        setAria(openDetails, false);
        summary.focus();
        return;
      }

      if (reduce) {
        newContent.classList.add('mm-reiter-stable');
        targetDetails.open = true;
        setAria(targetDetails, true);
        openDetails.open = false;
        setAria(openDetails, false);
        summary.focus();
        return;
      }

      var oldIdx = parseInt(openDetails.getAttribute('data-mm-index'), 10) || 0;
      var newIdx = parseInt(targetDetails.getAttribute('data-mm-index'), 10) || 0;
      var goForward = newIdx > oldIdx;
      var dirFwd = goForward ? 'mm-tab-dir-forward' : 'mm-tab-dir-back';

      openDetails.classList.add('mm-tab-exiting', dirFwd);

      setTimeout(function () {
        newContent.classList.add('mm-reiter-stable');
        /* entering vor open: sonst greift kurz die „center“-Regel und konkurriert mit mmTabLineIn */
        targetDetails.classList.add('mm-tab-entering', dirFwd);
        targetDetails.open = true;
        setAria(targetDetails, true);
        openDetails.open = false;
        setAria(openDetails, false);
        openDetails.classList.remove('mm-tab-exiting', 'mm-tab-dir-forward', 'mm-tab-dir-back');

        setTimeout(function () {
          targetDetails.classList.remove('mm-tab-entering', 'mm-tab-dir-forward', 'mm-tab-dir-back');
          summary.focus();
        }, TAB_LINE_ENTER_MS);
      }, TAB_LINE_EXIT_MS);
    },
    true
  );

  /*
   * Mega offen + Klick auf Direktlink: nur mm-tab-exiting am offenen Mega, dann Navigation.
   */
  document.addEventListener(
    'click',
    function (e) {
      if (!MQ || !MQ.matches) return;
      var a = e.target.closest && e.target.closest('a.header__menu-item');
      if (!a) return;
      if (a.closest('details.mega-menu')) return;
      var nav = a.closest(NAV_SEL);
      if (!nav) return;
      var openDetails = findOpenMega(nav);
      if (!openDetails) return;
      if (!isPlainPrimaryNavClick(e, a)) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var href = a.href;
      var reduce = MQ_REDUCE && MQ_REDUCE.matches;
      if (reduce) {
        openDetails.open = false;
        setAria(openDetails, false);
        window.location.assign(href);
        return;
      }

      var dirClass = megaTabDirClass(openDetails, a);
      openDetails.classList.add('mm-tab-exiting', dirClass);

      setTimeout(function () {
        openDetails.open = false;
        setAria(openDetails, false);
        openDetails.classList.remove('mm-tab-exiting', 'mm-tab-dir-forward', 'mm-tab-dir-back');
        var oc = openDetails.querySelector('.mega-menu__content');
        if (oc) oc.classList.remove('mm-reiter-stable');
        window.location.assign(href);
      }, TAB_LINE_EXIT_MS);
    },
    true
  );
})();
